module.exports = __webpack_public_path__ + "static/media/dialog_queen_mea_04.d95ffe2e.png";